import React, { useState } from "react";
import AddButton from "../../Component/UI/AddButton";
import { MdSearch, MdArrowForwardIos, MdArrowBackIos } from "react-icons/md";
import CommonTableCheckbox from "../../../AdminPanel/Component/UI/CommonTableCheckbox";
import { LuSend } from "react-icons/lu";

export default function CompareTeamMembers({ onClose, getDimensionCodeCode, list }) {

  function getThemes(ele = {}) {
    let listOne = [1, 2, 3, 4, 5]
      .map((rank) => {
        const name = ele[`Rank${rank.toString()}`];
        return name
          ? {
            name,
            rank,
            colorCode: "#757575"
          }
          : null;
      })
      .filter(Boolean);
    console.log("listOne--xasda-->", listOne)

    return listOne
  }
  console.log("list--xasda-->", list)

  return (

    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black/40" />

      <div className="relative bg-white w-full max-w-6xl rounded-2xl p-8 z-10">
        {/* Title */}
        <h2 className="text-xl font-semibold mb-4">Comparing Domimant Themes</h2>
        <div className="mb-10">
          <p className="text-gray-600 text-sm mt-1">Dominant Themes of each Team Members</p>
        </div>
        <div className="border rounded-lg bg-white p-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
            {list && list.length > 0 && list.map((inner) =>
              <div>
                <div className="px-2 py-2 mb-3 font-semibold bg-[#F2F2F2] flex justify-center
                   col-span-2 space-x-2 textcolor capitalize"><span>{inner.name}</span></div>
                <ul className="space-y-2">
                  {getThemes(inner) && getThemes(inner).length > 0 && getThemes(inner).map((item, index) => (
                    <>
                      <div className="pl-6 pb-1">
                        <div className={`relative flex items-center py-2 font-semibold text-lg pl-16 pr-12 w-full text-white `}
                          style={{ background: getDimensionCodeCode(item.name) }}>
                          <div className="absolute left-0 top-1/2 -translate-y-1/2 -ml-6">
                            <div className={`w-12 h-12 rounded-full flex items-center justify-center font-bold text-base border-4 border-white `}
                              style={{ background: getDimensionCodeCode(item.name) }}>
                              {item.rank}
                            </div>
                          </div>
                          {item.name}
                        </div>
                      </div>
                    </>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </div>

        <div className="flex justify-end gap-4 mt-6">
          <button onClick={() => onClose()} className="px-6 py-2 border rounded-md">Close</button>
        </div>
      </div>
    </div>
  );
}
